import './CountrySelector.css';
import classes from './CountrySelector.module.css';
import { Autocomplete, TextField, Checkbox } from "@mui/material"
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useContext, useEffect, useState } from "react"
import OfferContext from '../../store/OfferContext';
import CurrencyContext from '../../store/CurrencyContext';
import { useTranslation } from 'react-i18next';

// icons for Material UI checkboxes
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CountrySelector = () => {
    const offerCtx = useContext(OfferContext)
    const currencyCtx = useContext(CurrencyContext)
    const languageParentWindow = currencyCtx.languageParentWindow
    const [selectedOptions, setSelectedOptions] = useState([]);

    const { t } = useTranslation('common');

    let ctxSelectedCountryDefault = offerCtx.selectedDefaultCountryName

    // Populate select options
    const options = offerCtx.loadedCountries.map((country) => {
        if (languageParentWindow === 'en') {
            return {
                label: country.name,
                value: country.code
            }
        } else {
            return {
                label: country.nameFrench.common,
                value: country.code
            }
        }
    })
    // Sort country select options in alphabetic order
    options.sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();

        if (labelA < labelB) {
            return -1;
        }
        if (labelA > labelB) {
            return 1;
        }
        return 0;
    });

    // Filter select options based on input value
    const filterOptions = (options, { inputValue }) => {
        return options.filter((option) => {
            const optionNormalized = toNormalForm(option.label)
            const inputValueNormalized = toNormalForm(inputValue)
            return optionNormalized.toLowerCase().startsWith(inputValueNormalized.toLowerCase())
        });
    };

    // Changing countries in the selector
    const handleChange = (event, values) => {
        const selectedCountryObjects = Array.isArray(values) ? values : [values];
        setSelectedOptions(selectedCountryObjects);
        const selectedCountries = selectedCountryObjects.map((item) => item.value);
        offerCtx.changeCountries(selectedCountries);
    };
      

    const toNormalForm = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    const isOptionEqualToValue = (option, value) => {
        return option?.value === value?.value;
    };

    useEffect(() => {
        if (
            offerCtx.isLoaded &&
            ctxSelectedCountryDefault &&
            offerCtx.selectedCountries.length === 0
          ) {
            const defaultCountryObj = {
              value: ctxSelectedCountryDefault.value,
              label: languageParentWindow === 'fr'
                ? ctxSelectedCountryDefault.labelFrench
                : ctxSelectedCountryDefault.labelEnglish
            };
            setSelectedOptions([defaultCountryObj]);
            offerCtx.changeCountries([defaultCountryObj.value]);
          }
          
    /* eslint-disable react-hooks/exhaustive-deps */
    }, [languageParentWindow, offerCtx.selectedDefaultCountryName]);

    useEffect(() => {
        const updated = offerCtx.selectedCountries.map((code) => {
          const country = offerCtx.loadedCountries.find((c) => c.code === code);
          if (!country) return null;
          return {
            value: code,
            label: languageParentWindow === 'en' ? country.name : country.nameFrench.common
          };
        }).filter(Boolean);
        setSelectedOptions(updated);
      }, [languageParentWindow, offerCtx.selectedCountries, offerCtx.loadedCountries]);

    if (offerCtx.error) {
        return <div>Error: {offerCtx.error}</div>;
    } else if (!offerCtx.isLoaded) {
        return <div>Loading...</div>;
    } else {
        return (
            <>
                <Autocomplete className={classes.materialUIBox}
                    // configuring autocomplete search function
                    isOptionEqualToValue={isOptionEqualToValue}
                    disablePortal
                    openText={t('label.open')}
                    closeText={t('label.close')}
                    clearText={t('label.clear')}
                    multiple
                    limitTags={1}
                    id="combo-box-demo"
                    options={options}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                checked={selected}
                            />
                            {option.label}
                        </li>
                    )}
                    sx={{ width: 300 }}
                    filterOptions={filterOptions}
                    value={selectedOptions}
                    onChange={handleChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t('country.choose')}
                            // borderRadius="16px"
                            style={{
                                textAlign: "left",
                                color: "black"
                            }}
                        />
                    )}
                />
            </>
        );
    }

}

export default CountrySelector
